import "./About.css";

export default function About() {
  return (
    <section id="about" className="about">

      <h2 className="about-title">
        Transparent Service for Trust & Customer Satisfaction
      </h2>

      <div className="about-container">

        <div className="about-card">
          <span className="icon">👥</span>
          <h3>50,000+</h3>
          <p>Happy Customers</p>
        </div>

        <div className="about-card">
          <span className="icon">🏆</span>
          <h3>20+</h3>
          <p>Prestigious Awards</p>
        </div>

        <div className="about-card">
          <span className="icon">🎧</span>
          <h3>150+</h3>
          <p>Dedicated Support Team</p>
        </div>

        <div className="about-card">
          <span className="icon">🏪</span>
          <h3>33+</h3>
          <p>Branches</p>
        </div>

      </div>

    </section>
  );
}